"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useLazyRef = _interopRequireDefault(require("../useLazyRef"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useLifeCycle = function useLifeCycle(props) {
  var willMountCallbackRef = (0, _useLazyRef.default)(function () {
    return props === null || props === void 0 ? void 0 : props.willMount;
  });
  var didMountCallbackRef = (0, _useLazyRef.default)(function () {
    return props === null || props === void 0 ? void 0 : props.didMount;
  });
  var willUnmountCallbackRef = (0, _useLazyRef.default)(function () {
    return props === null || props === void 0 ? void 0 : props.willUnmount;
  });
  var _a = (0, _react.useState)(false),
    isMounted = _a[0],
    isMountedSet = _a[1];
  // Mimic componentWillMount in a class component
  // This hook will run 'willMount()' only once before the first render
  (0, _react.useEffect)(function () {
    if (typeof willMountCallbackRef.current === 'function') {
      willMountCallbackRef.current();
    }
  }, [willMountCallbackRef]);
  (0, _react.useEffect)(function () {
    isMountedSet(true);
  }, []);
  // Mimic componentDidMount in a class component
  // This hook will run 'didMount()' only once after the first render
  (0, _react.useEffect)(function () {
    var willUnmountcallback = willUnmountCallbackRef.current;
    if (isMounted && typeof didMountCallbackRef.current === 'function') {
      didMountCallbackRef.current();
    }
    return function () {
      if (typeof willUnmountcallback === 'function') {
        willUnmountcallback();
      }
    };
  }, [isMounted, didMountCallbackRef, willUnmountCallbackRef]);
  // Mimic componentWillUnmount in a class component
  // This hook will run 'willUnmount()' only once when unmount
  (0, _react.useEffect)(function () {
    var willUnmountcallback = willUnmountCallbackRef.current;
    return function () {
      if (typeof willUnmountcallback === 'function') {
        willUnmountcallback();
      }
    };
  }, [willUnmountCallbackRef]);
};
var _default = useLifeCycle;
exports.default = _default;